import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import axios from "../../axios/axios";

import PageHeader from "../../components/PageHeader";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/Close";

import DataGrid from "../../components/useDataGrid";
import Popup from "../../components/Popup";
import Controls from "../../components/Controls";
import ConfirmDialog from "../../components/ConfirmDialog";
import Notification from "../../components/Notification";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import { Stack } from "@mui/system";
import { MyUseForm, MyForm } from "../../components/useForm";

import * as GenServices from "../../helper/GenServices";
import { useSelector, useDispatch } from "react-redux";
import { setAllFeeHeadsMasterList } from "../../redux/actions";

const initialValues = {
  //_id: "",
  hid: "3",
  // feeHeadMID: "",
  feeHeadMain: "",
  type: "GENERAL",
  showInMisc: false,
  isActive: true,
  sorting: 1,
  staffUN: "",
  ip: "",
  feeHeads: [],
};

export default function FeeHeadMain() {
  
  const dispatch = useDispatch();
  const AllFeeHeads = useSelector((state) => state.FeeHeadList_Reducer.feeHeadMain);

  // console.log("AllFeeHeads==>  ", AllFeeHeads);

  // const [records, setRecords] = useState([]);
  // const [recordForEdit, setRecordForEdit] = useState(null);
  const [notify, setNotify] = useState({ isOpen: false, message: "", type: "" });
  const [confirmDialog, setConfirmDialog] = React.useState({
    isOpen: false,
    isConfirm: null,
    title: "title",
    subtitle: "subtitle",
  });

  const validate = (fieldValues = formValues) => {
    let temp = { ...errors };

    // console.log("fieldValues =====>", fieldValues.dob);
    if ("feeHeadMain" in fieldValues) temp.feeHeadMain = fieldValues.feeHeadMain ? "" : "required.";

    setErrors({
      ...temp,
    });
    // console.log("temp===>", temp);
    if ((fieldValues = formValues)) return Object.values(temp).every((x) => x == "");
  };

  const { formValues, setFormValues, errors, setErrors, handleChange } = MyUseForm(initialValues, true, validate);

  const getRecord = async () => {
    try {
      const res = await axios.get("/fee/headlist");
      
      console.log("getRecord by FeeHeadMain  ===>", res);

      if (res) {
        // setRecords(res.data);
        dispatch(setAllFeeHeadsMasterList(res.data));
        // console.log("res.data ===>", res.data)
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
    //setLoading(false);
  };

  useEffect(() => {
    getRecord();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // console.log("validate ===>", errors);
      addOrEdit(formValues);
    } else {
      setNotify({ isOpen: true, message: "Please enter the value in required fields!", type: "error" });
      //  console.log(errors)
    }
  };

  const resetForm = () => {
    setFormValues(initialValues);
    // setRegnValues(initialValuesRegn);
    // setRecordForEdit(null);
    setErrors({});
    setNotify({ isOpen: false, message: "", type: "" });
    // setMRNoValueForReport("");
  };

  const bindData = () => {
    resetForm();
    // setRecordForEdit(null);
    setFormValues(initialValues);
    getRecord();
  };

  const addOrEdit = async (data) => {
    // const data = {...formValues};
    // console.log("data addOrEdit =========>", data);
    // const queryobj = { params: { mrNo: 1234 } }; //<=== this query only for testing
    if (data._id) {
      //This is for Update
      // RegnServices.updatePatient(data);
      try {
        // console.log("axios patch Start===>", data);
        const res = await axios.patch(`/fee/headlist/${data._id}`, data); //, queryobj);
        // console.log("axios.patch response===>", res);
        if (res) {
          bindData();
          setNotify({ isOpen: true, message: "Updated Successfully", type: "success" });
        }
      } catch (error) {
        console.error("error=====>", error);
        setNotify({ isOpen: true, message: error.message, type: "error" });
      }
    } else {
      //This is for Create new
      try {
        // console.log("axios Insert Start===>", data);
        const res = await axios.post("/fee/headlist", data);
        // console.log("axios Insert response===>", res);
        if (res) {
          bindData();
          setNotify({ isOpen: true, message: "Saved Successfully", type: "success" });
        }
      } catch (error) {
        console.error("error=====>", error);
        setNotify({ isOpen: true, message: error.message, type: "error" });
      }
    }
  };

  const onDelete = async (id) => {
    //if (window.confirm("Do you want to delete this record?")) {
    try {
      // console.log("axios.patch===>", Patient);
      setConfirmDialog({ ...confirmDialog, isOpen: false });
      const res = await axios.delete(`/fee/headlist/${id}`);
      if (res) {
        setNotify({ isOpen: true, message: "Deleted Successfully", type: "success" });
        await getRecord();
      }
    } catch (error) {
      console.error("error=====>", error);
      setNotify({ isOpen: true, message: error.message, type: "error" });
    }
    // RegnServices.deletePatient(id);
  };

  const handleClickDelete = (data) => {
    //if (window.confirm("Do you want to delete this record?")) {
    // console.log("data.row._id", data)
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subtitle: "You can't undo this operation",
      isConfirm: () => {
        onDelete(data._id);
      },
    });
  };

  const openInEdit = (data) => {
    // console.log("data  aaaaaaa", data);
    setFormValues(data);
  };
  
  const isActive_Changed = (e, data) => {
    data.isActive = e.target.value;
    // console.log("data  aaaaaaa", data);
    addOrEdit(data);
  };

  const columns = [
    // { field: "_id", headerName: "_id", width: 230 },
    { field: "feeHeadMain", headerName: "Fee-Head-Main", width: 250, editable: true },
    { field: "type", headerName: "Type", width: 150 },
    // { field: "showInMisc", headerName: "ShowInMisc", width: 120 },
    // { field: "isActive", headerName: "Active", width: 150 },
    {
      field: "isActive",
      headerName: "Is-Active",
      width: 100,
      sortable: false,
      renderCell: (curObj) => {
        return (
          <Controls.Checkbox
            label={curObj.row.isActive.toString()}
            name="isActive"
            value={curObj.row.isActive}
            onChange={(e) => isActive_Changed(e, curObj.row)}
          />
        );
      },
    },
    // { field: "staffUN", headerName: "StaffUN", width: 150 },
    // { field: "ip", headerName: "Terminal IP", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (curObj) => {
        return (
          <>
            <Stack direction="row" spacing={1}>
              <Controls.ActionButton color="primary" title="Edit" onClick={() => openInEdit(curObj.row)}>
                <ModeEditOutlineIcon />
              </Controls.ActionButton>
              <Controls.ActionButton color="red" title="Delete" onClick={() => handleClickDelete(curObj.row)}>
                <CloseIcon />
              </Controls.ActionButton>
            </Stack>
          </>
        );
      },
    },
  ];

  return (
    <div>
      <h2>Add Fee Head Main</h2>

      <MyForm onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* feeHeadMain */}
          <Grid item xs={12} sm={12} md={6} lg={3}>
            <Controls.Input
              label="FeeHeadMain"
              name="feeHeadMain"
              value={formValues.feeHeadMain}
              onChange={handleChange}
              error={errors.feeHeadMain}
            />
          </Grid>

          {/* type */}
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Controls.DropdownList
              label="Type"
              name="type"
              value={formValues.type}
              onChange={handleChange}
              options={GenServices.FeeHeadTypeValues}
              // error={errors.type}
            />
          </Grid>

          {/* showInMisc */}
          {/* <Grid item xs={6} sm={4} md={3} lg={2}>
            <Controls.Checkbox
              label="Show-In-Misc."
              name="showInMisc"
              value={formValues.showInMisc}
              onChange={handleChange}
              // error={errors.showInMisc}
            />
          </Grid> */}

          {/* isActive */}
          {/* <Grid item xs={6} sm={4} md={3} lg={2}>
            <Controls.Checkbox
              label="Is-Active"
              name="isActive"
              value={formValues.isActive}
              onChange={handleChange}
              // error={errors.isActive}
            />
          </Grid> */}

          {/* Button */}
          <Grid item xs={12} sm={12} md={6} lg={3} alignContent="center">
            <Controls.Button
              sx={{ mx: "10px" }}
              text="Save"
              //onClick={() => console.log(formValues)}
              //variant="outlined"
              type="submit"
              startIcon={<SaveRoundedIcon />}
            />
            <Controls.Button
              text="Reset"
              onClick={resetForm}
              //variant="outlined"
              startIcon={<RestartAltIcon />}
              // color="default"
            />
          </Grid>

          {/* <Grid item sm={12}>
          <FormControlLabel control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Grid> */}

          {/* <Grid item sm={12} md={3}>
          <FormGroup row>  
            
            <TextField label="Test-Name" variant="standard" placeholder="username" />
            </FormGroup>
        </Grid> */}
        </Grid>
      </MyForm>
      <br></br>
      <DataGrid heading="Fee-Head-Main" columns={columns} rows={AllFeeHeads} pageSize={50} boxHeight={680} />

      <br></br>

      <Notification notify={notify} setNotify={setNotify} />

      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </div>
  );
}
